import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Picker, List, WhiteSpace , ListView, Toast } from 'antd-mobile/lib';
import { createForm } from 'rc-form';
import Util from '../../util.js';
import ReactDOM from 'react-dom';

import { getQueryTradeRecords, getHistoryIcomeListSuper ,getSupperFundHome} from '../../action/investmentAction';
import { compareDate, compareTime, compareTimeTwo, getDateNow, get3MonthBefor, get1yearBefor, getOneMonthBefor, getSixMonthBefor, getDateS} from '../../getPay';
import ChooseTime from './ChooseTime';

import { hashHistory } from 'react-router';
import NavigatorMain from '../NavigatorMain';

function MyBody(props) {
  return (
    <div className="am-list-body my-body">
      <span style={{ display: 'none' }}>you can custom body wrap element</span>
      {props.children}
    </div>
  );
}

const data = [
  {
    img: 'https://zos.alipayobjects.com/rmsportal/dKbkpPXKfvZzWCM.png',
    title: 'Meet hotel',
    des: '不是所有的兼职汪都需要风吹日晒',
  },
  {
    img: 'https://zos.alipayobjects.com/rmsportal/XmwCzSeJiqpkuMB.png',
    title: 'McDonald\'s invites you',
    des: '不是所有的兼职汪都需要风吹日晒',
  },
  {
    img: 'https://zos.alipayobjects.com/rmsportal/hfVtzEhPzTUewPm.png',
    title: 'Eat the week',
    des: '不是所有的兼职汪都需要风吹日晒',
  },
];


let content = [{"dayIncome":"--","allIncome":"-19475.84","deadLine":"2017-11-16","allIncomeNext":"-19475.84","serialNo":1},{"dayIncome":"--","allIncome":"-19475.84","deadLine":"2017-11-15","allIncomeNext":"-19475.84","serialNo":2},{"dayIncome":"--","allIncome":"-19475.84","deadLine":"2017-11-14","allIncomeNext":"-19475.84","serialNo":3},{"dayIncome":"--","allIncome":"-19475.84","deadLine":"2017-11-13","allIncomeNext":"-19475.84","serialNo":4},{"dayIncome":"--","allIncome":"-19475.84","deadLine":"2017-11-12","allIncomeNext":"-19475.84","serialNo":5},{"dayIncome":"--","allIncome":"-19475.84","deadLine":"2017-11-11","allIncomeNext":"-19475.84","serialNo":6},{"dayIncome":"--","allIncome":"-19475.84","deadLine":"2017-11-10","allIncomeNext":"-19475.84","serialNo":7},{"dayIncome":"--","allIncome":"-19475.84","deadLine":"2017-11-09","allIncomeNext":"-19475.84","serialNo":8},{"dayIncome":"--","allIncome":"-19475.84","deadLine":"2017-11-08","allIncomeNext":"-19475.84","serialNo":9},{"dayIncome":"--","allIncome":"-19475.84","deadLine":"2017-11-07","allIncomeNext":"-19475.84","serialNo":10},{"dayIncome":"--","allIncome":"-19475.84","deadLine":"2017-11-06","allIncomeNext":"-19475.84","serialNo":11},{"dayIncome":"--","allIncome":"-19475.84","deadLine":"2017-11-05","allIncomeNext":"-19475.84","serialNo":12},{"dayIncome":"--","allIncome":"-19475.84","deadLine":"2017-11-04","allIncomeNext":"-19475.84","serialNo":13},{"dayIncome":"--","allIncome":"-19475.84","deadLine":"2017-11-03","allIncomeNext":"-19475.84","serialNo":14},{"dayIncome":"--","allIncome":"-19475.84","deadLine":"2017-11-02","allIncomeNext":"-19475.84","serialNo":15},{"dayIncome":"--","allIncome":"-19475.84","deadLine":"2017-11-01","allIncomeNext":"-19475.84","serialNo":16}]

const NUM_SECTIONS = 5;
const NUM_ROWS_PER_SECTION = 5;
let pageIndex = 0;



const seasonsTime = [
    {
      label: '全部时间',
      value: '0',
      key:0
    },
    {
      label: '近一个月',
      value: '1',
      key:1
    },
    {
      label: '近三个月',
      value: '3',
      key:2
    },
    {
      label: '近半年',
      value: '6',
      key:3
    },
    {
      label: '自选周期',
      value: 'zx',
      key:4
    },
];


/*智投历史收益查询*/
class HistoryProfit extends Component {
  constructor(props) {
    super(props);
    let ds = new ListView.DataSource({rowHasChanged: (r1, r2) => r1 !== r2});
    let ua=navigator.userAgent.toLowerCase();
    this.state = {
      modalFlag:false,
      sValue:[""],
      timeValue:["0"],
      seasons:[],
      allIncomes:0,
      fundCode:"",
      beginDate:GetDateStr(getDateNow()),
      endDate:getDateNow(),
      chooseBeginDate:"1990-01-01",
      chooseEndDate:getDateNow(),
      totalDataArr: [],
      dataSource: ds.cloneWithRows([]),
      handleFlag:true,
      //dataSource,
      isLoading: true,
      content:[],
      height: (ua.indexOf("hxcfH5WX") != -1 || ua.match(/MicroMessenger/i)=="micromessenger" ) ? (window.winHeight - 86) : (window.winHeight - 88 - 44),
      zxFlag:false
    };
    
  }
  componentWillMount(){
    let ua=navigator.userAgent.toLowerCase();
    console.log(ua.indexOf("hxcfH5WX"),"ua.indexOf")

    document.title = '历史收益查询'
    let { dispatch } = this.props;
    let that = this;
    let data = {
      superFundCode:"",
      pageIndex:1,
      pageSize:99,
    }
    document.getElementsByTagName('title')[0].innerHTML = "历史收益查询";
    // dispatch(getHistoryIcomeListSuper(data,this.callbackData.bind(this),that))
    // dispatch(getSupperFundHome({},(data)=>{},this))
    dispatch(getSupperFundHome({},(data)=>{
        console.log(data.singleSuperFundViews,"datadatadata",data)
        //let superHome = data ? ( data.singleSuperFundViews ? data.singleSuperFundViews : []) : null
        this.setState({
          superHome:data,
        })
    },this));
  }
  componentDidMount(){


    let ds = new ListView.DataSource({rowHasChanged: (r1, r2) => r1 !== r2});
    let data = {
        beginDate:this.state.beginDate,
        fundCode:this.state.fundCode,
        endDate:this.state.endDate,
    }

    Toast.loading('', 0, () => {});
    this.props.dispatch(getHistoryIcomeListSuper(data,this.handleCallback.bind(this),this))

    // const hei = window.winHeight - ReactDOM.findDOMNode(this.lv).parentNode.offsetTop;
    const hei = window.winHeight - 88 - 45;
    // simulate initial Ajax
    // setTimeout(() => {

    //   this.setState({
    //     dataSource: ds.cloneWithRows([]),
    //     //dataSource: this.state.dataSource.cloneWithRowsAndSections(dataBlobs, sectionIDs, rowIDs),
    //     // isLoading: false,
    //     height: hei,
    //   });
    // }, 600);
  }
  onEndReached = (event) => {
    let _this = this;
    // load new data
    // hasMore: from backend data, indicates whether it is the last page, here is false
    if (this.state.isLoading && !this.state.hasMore) {
      return;
    }

    let ds = new ListView.DataSource({rowHasChanged: (r1, r2) => r1 !== r2});
    console.log('reach end', event);
    let da = this.state.content.concat(content)
    console.log(da,"dadaadadadada")
    this.setState({ isLoading: true });

      // genData(++pageIndex);
    // setTimeout(() => {
    //   console.log("timetiem")
    //   this.setState({
    //     content:da,
    //     dataSource: ds.cloneWithRows(da),
    //     //dataSource:this.state.dataSource.cloneWithRowsAndSections(dataBlobs, sectionIDs, rowIDs),
    //     isLoading: false,
    //   });
    // })

    // this.setState({
    //   nomore:true
    // })
    let dataArr = [];
    let totalDataArr = [];
    // console.log(this.state.dataSource._cachedRowCount,"********", dataProps.length)
    let { dispatch } = this.props;

    // console.log(this.state.dataSource._cachedRowCount,"********", dataProps.length)
    let data = {
        beginDate:this.state.beginDate,
        fundCode:this.state.fundCode,
        endDate:this.state.endDate,
    }
    // this.setState({nomore:true}, ()=> {
    //   dispatch(getHistoryIcomeListSuper(data,this.handleCallback.bind(this),_this))
    // });
    console.log(this.state.chooseBeginDate, this.state.beginDate,"时间时间",this.state.handleFlag)

    if(compareTimeTwo(this.state.chooseBeginDate,this.state.beginDate) && !this.state.handleFlag){
      // Toast.loading('', 0, () => {});
      dispatch(getHistoryIcomeListSuper(data,this.handleCallback.bind(_this),_this))
    }else{

      this.setState({

        isLoading:0
      })
    }

  }

  handleCallback(data){

    console.log(data,"datada******tadata")
    let ds = new ListView.DataSource({rowHasChanged: (r1, r2) => r1 !== r2});
    let allIncomes = 0 ;
    let totalDataArr = this.state.totalDataArr.concat(data);
    if(data.length === 0){
      this.setState({

        isLoading:0
      })
    }else if(data.length < 15){
      this.setState({
  
        dataSource: ds.cloneWithRows(totalDataArr),
        totalDataArr:totalDataArr,
        isLoading:0,
        allIncomes:totalDataArr[0].allIncome,
        endDate:GetDateStr(this.state.beginDate,-1),
        beginDate:GetDateStr(this.state.beginDate),
      })
    }else{
      this.setState({
        dataSource: ds.cloneWithRows(totalDataArr),
        totalDataArr:totalDataArr,
        allIncomes:totalDataArr[0].allIncome,
   
        handleFlag:false,
        endDate:GetDateStr(this.state.beginDate,-1),
        beginDate:GetDateStr(this.state.beginDate),
        isLoading: false,
      })
    }
    // Toast.hide()
  }
  callbackData(data){
    console.log(data,"************")
  }
  goBack(){
    hashHistory.go(-1)
    // let pathName = this.props.location.state.pathName ? this.props.location.state.pathName :'/';
    // let data = this.props.location.state.data ? this.props.location.state.data : null;
    // hashHistory.push({
    //     pathname:pathName,
    //     state:{
          
    //     }
    // })
  }

  goTransactionDetail(item){
    let data = {
      businessType:item.businessType,
      tradeRequestId:item.tradeRequestId
    }
    hashHistory.push({
        pathname:'/TransactionDetail',
        state:{
          data
        }
    })
  }

  handleProduct(e){
    let { dispatch } = this.props;
    console.log(e,"eeeeee")
    //this.setState({ sValue:e })
    // let data = {
    //   superFundCode:e[0],
    //   pageIndex:1,
    //   pageSize:30,
    // }
    let tempbeginDate = compareTimeTwo(GetDateStr(this.state.chooseEndDate),this.state.chooseBeginDate) ?  this.state.chooseBeginDate : GetDateStr(this.state.chooseEndDate)
     let data = {
        beginDate:tempbeginDate,
        fundCode:e[0],
        endDate:this.state.chooseEndDate,
    }

    const ds = new ListView.DataSource({rowHasChanged: (r1, r2) => r1 !== r2});
    this.setState({
      isLoading:true,
      productAll:false,
      sValue:e,
      fundCode:e[0],
      beginDate:tempbeginDate,
      endDate:this.state.chooseEndDate,
      dataSource: ds.cloneWithRows([]),
      totalDataArr:[],
      allIncomes:0,
      handleFlag:true
    })

    console.log(data,"allInData**78787878",GetDateStr(this.state.chooseEndDate), this.state.chooseEndDate)
    if(e[0] === "0000"){
      data.superFundCode = ""
    }
    dispatch(getHistoryIcomeListSuper(data,this.handleCallback.bind(this),this));
  }
  handleTime(e){
    let { dispatch } = this.props;
    console.log(e,"eeeeee")
    let dateNow = null;
    if(e[0] == "1"){
      dateNow = getOneMonthBefor()
    }else if(e[0] == "3"){
      dateNow = get3MonthBefor()
    }else if(e[0] == "6"){
      dateNow = getSixMonthBefor()
    }else{
      dateNow = "1990-09-09"
    }
    const ds = new ListView.DataSource({rowHasChanged: (r1, r2) => r1 !== r2});

    console.log(dateNow,"dateNowdateNowdateNowdateNow")

    this.setState({

      isLoading:true,
      timeAll:false,
      timeValue:e,
      chooseBeginDate:dateNow,
      chooseEndDate:getDateNow(),
      allIncomes:0,
      beginDate:GetDateStr(getDateNow()),
      endDate:getDateNow(),
      totalDataArr:[],
      dataSource: ds.cloneWithRows([]),
      handleFlag:true
    })
    let data = {
      beginDate:GetDateStr(getDateNow()),
      fundCode:this.state.fundCode,
      endDate:getDateNow(),
    }
    if(e[0] === "0000"){
      data.superFundCode = ""
    }
    if(e[0] === "zx"){
      // hashHistory.push({
      //     pathname:'/ChooseTime',
      //     state:{
      //       data
      //     }
      // })
      this.setState({
        zxFlag:true
      })
    }else{
      dispatch(getHistoryIcomeListSuper(data,this.handleCallback.bind(this),this))
    }
  }
  renderFooter(){
    console.log("有无加载",this.state.isLoading)
    if(this.state.isLoading === true){
      return(
        <div style={{ height: 0, textAlign: 'center' }}>
          正在加载...
        </div>
      )
    }else if(this.state.isLoading === false){
      return(
        <div style={{ height: 0, textAlign: 'center' }}>
          加载完成            
        </div>
      )
    }else if(this.state.isLoading === 0){
      return(
        <div style={{ height: 0, textAlign: 'center' }}>
          没有更多数据了
       </div>
      )
    }
  }
  ChooseTimeCallback2(sDate,eDate){


    console.log("开始和结束时间",sDate,eDate)
    this.setState({
      zxFlag:false
    })
  }
  ChooseTimeCallback(sTime,eTime){
    let _this = this;
    let { dispatch } = _this.props;
    const ds = new ListView.DataSource({rowHasChanged: (r1, r2) => r1 !== r2});
    
    if(compareDate(sTime,eTime)){
        this.setState({
        isLoading:true,
        zxFlag:false,
        productAll:false,
        dataSource: ds.cloneWithRows([]),
        totalDataArr:[],
        handleFlag:true,
        allIncomes:0,
        chooseBeginDate:sTime,
        chooseEndDate:eTime,
        beginDate:compareTimeTwo(GetDateStr(eTime),sTime) ? sTime : GetDateStr(eTime),
        endDate:eTime,
      })
      let data = {
          beginDate:compareTimeTwo(GetDateStr(eTime),sTime) ? sTime : GetDateStr(eTime),
          endDate:eTime,
          fundCode:this.state.fundCode,
      }
      dispatch(getHistoryIcomeListSuper(data,this.handleCallback.bind(this),this));
    }else{
      Toast.info("起始时间不能大于终止时间", Util.ToastTime );
    }
  }
  closeChoose(){
    this.setState({
      zxFlag:false
    })
  }
  render() {
    let data = this.props.QueryTradeRecords ? this.props.QueryTradeRecords : [];
    let tempData = [{businessTime:"0000"}];
    tempData = tempData.concat(data);
    let { allIncomes , zxFlag, superHome} = this.state;
    let seasons = [
        {
          label: '全部产品',
          value: '',
          key:0
        }
    ];
     superHome ?
    (superHome.singleSuperFundViews ? superHome.singleSuperFundViews.map(function(itme,i){
      seasons.push({
        label: itme.superFundName,
        value: itme.superFundCode,
        key:i+2
      })
    }) : null ) : null

    let heihgt = window.winHeight;
    const hei = window.winHeight - 86;

    const separator = (sectionID, rowID) => (
      <div
        key={`${sectionID}-${rowID}`}
        style={{
          backgroundColor: '#F5F5F9',
          height: 8,
          borderTop: '1px solid #ECECED',
          borderBottom: '1px solid #ECECED',
        }}
      />
    );
    let row = (rowData, sectionID, rowID) => {
      // if (index < 0) {
       
      //   index = content.length - 1;
      // }
      // const obj = content[index--];
      console.log(rowID,"rowID")
        return(
          <div style={{ background:"#FFF" }}>
            <div style={{display:"flex", height:"45px", justifyContent:"space-between", flexDirection:"row", alignItems:"center", paddingLeft:"13px", paddingRight:"13px" }}>
              <span style={{fontSize:"13px", color:"#5b6370" }}>{ rowData.deadLine }</span><span style={{fontSize:"13px", color:rowData.dayIncome >=0 || rowData.dayIncome == "--" ? "#fb615b" : "#7fdd81"}}>{ rowData.dayIncome }</span>
            </div>
          </div>
        )
      // return (
      //   <div key={rowID} style={{ padding: '0 15px' }}>
      //     <div
      //       style={{
      //         lineHeight: '50px',
      //         color: '#888',
      //         fontSize: 18,
      //         borderBottom: '1px solid #F6F6F6',
      //       }}
      //     >{obj.title}</div>
      //     <div style={{ display: '-webkit-box', display: 'flex', padding: '15px 0' }}>
      //       <img style={{ height: '64px', marginRight: '15px' }} src={obj.img} alt="" />
      //       <div style={{ lineHeight: 1 }}>
      //         <div style={{ marginBottom: '8px', fontWeight: 'bold' }}>{obj.des}</div>
      //         <div><span style={{ fontSize: '30px', color: '#FF6E27' }}>35</span>¥ {rowID}</div>
      //       </div>
      //     </div>
      //   </div>
      // );
    };


    return (
        <div className="container">
          <NavigatorMain>
          <div className="header black">
            <div style={{ WebkitFlex: 1, flex:1 }}><span className="headerLeftBtn" onClick={ ()=> this.goBack() }></span></div>
            <div style={{ WebkitFlex: 2, flex:2, textAlign:'center',fontSize:"0.3rem" }}>历史收益查询</div>
            <div style={{ WebkitFlex: 1, flex:1, textAlign:'right',fontSize:"0.28rem", paddingRight:'0.26rem'}}></div>    
          </div>
          </NavigatorMain>
          <div className='content'>
          {/*
          <div className="chooseBottom">
            <span>全部产品</span><span></span>
          </div>*/}
          <div className="chooseSelects_Wrap" style={{ display:"-webkit-flex", display:"flex" }}>
            <div className="chooseSelect_Wrap" >
                <Picker data={seasons} cols={1} className="forss" title="产品" value={this.state.sValue}  onPickerChange={e => console.log('onPickerChange', e)} onOk={(e)=>{ this.handleProduct(e) } } >
                  <List.Item></List.Item>
                </Picker>
                <div  className="rightBottomArrow" style={{position:'absolute',right:'0.36rem', top:"50%", zIndex:2}}></div>
            </div>
            <div className="chooseSelect_Wrap" >
                <Picker data={seasonsTime} cols={1} className="forss" title="时间" value={this.state.timeValue}  onPickerChange={e => console.log('onPickerChange', e)} onOk={(e)=>{ this.handleTime(e) } } >
                  <List.Item></List.Item>
                </Picker>
                <div  className="rightBottomArrow" style={{position:'absolute',right:'0.36rem', top:"50%", zIndex:2}}></div>
            </div>
          </div>


          {/*<div style={{ backgroundColor:"#f2f5f7", paddingTop:"6px" }}>
            <div style={{ height:"45px", borderBottom:"1px solid #ebeef0", display:"flex", justifyContent:"space-between", flexDirection:"row", alignItems:"center", paddingLeft:"13px", paddingRight:"13px" }}>
              <span style={{fontSize:13 }}>累计盈亏(元)</span>
              <span style={{color:"#fb615b", fontSize:13 }}>356.60</span>
            </div>
          </div>
          <div style={{ background:"#FFF", overflow:"auto"}}>
            <div style={{display:"flex", height:"45px", justifyContent:"space-between", flexDirection:"row", alignItems:"center", paddingLeft:"13px", paddingRight:"13px" }}>
              <span style={{fontSize:"13px", color:"#5b6370" }}>2017-7-21</span><span style={{fontSize:"13px", color:"#fb615b"}}>24.3</span>
            </div>
          </div>

          <div style={{ background:"#FFF", overflow:"auto"}}>
            <div style={{display:"flex", height:"45px", justifyContent:"space-between", flexDirection:"row", alignItems:"center", paddingLeft:"13px", paddingRight:"13px" }}>
              <span style={{fontSize:"13px", color:"#5b6370" }}>2017-7-21</span><span style={{fontSize:"13px", color:"#7fdd81"}}> -24.3 </span>
            </div>
          </div>*/}
          <div className="Adjust_listHeaderInconme"><span style={{ fontSize:"13px", color:"#5b6370"}}>累计盈亏(元)</span><span style={{ color:allIncomes >=0 ? "#fb615b" : "#7fdd81" }}>{ allIncomes }</span></div>
          <div className="ListViewWrap">
            <ListView
              ref={el => this.lv = el}
              dataSource={this.state.dataSource}
              renderFooter={()=> this.renderFooter() }
              renderBodyComponent={() => <MyBody />}
              renderRow={(rowData, sectionID, rowID) => <div>
                <div style={{ background:"#FFF", overflow:"auto"}}>
                  <div className="HistoryProfitList">
                    <span style={{fontSize:"13px", color:"#5b6370" }}>{ rowData.deadLine }</span><span style={{fontSize:"13px", color:rowData.dayIncome >=0 || rowData.dayIncome == "--" ? "#fb615b" : "#7fdd81"}}>{ rowData.dayIncome }</span>
                  </div>
                </div>
              </div>

              }
              
              renderSeparator={separator}
              style={{
                height: this.state.height,
                overflow: 'auto',
              }}
              pageSize={4}
              onScroll={() => { console.log('scroll'); }}
              scrollRenderAheadDistance={500}
              onEndReached={this.onEndReached}
              onEndReachedThreshold={15}
              initialListSize = { 15 }
            />
          </div>


          {/*
            data.map((item,i)=>{
              let index = i;
              return(
                <div key = { i }>
                  {
                    tempData[index].businessTime.substr(0,7) != item.businessTime.substr(0,7) ?  <div style={{height:"1rem",paddingTop:"0.32rem",paddingLeft:'0.26rem', fontSize:'0.36rem', color:'#3a3e47', fontWeight:'800'}}>{ item.businessTime.substr(0,7) }</div> :null
                  }
                  <div className="superListJ" key = { i } onClick={ ()=> this.goTransactionDetail(item) } >
                    <div style={{ borderBottom:'1px solid #f2f4f7'}}>
                      <span style={{ color:'#fa063a'}}>
                        { item.businessTypeName }
                      </span>
                      <span></span>
                    </div>
                    <div><span>{ item.fundName }</span><span>{ Util.fomatFloat(item.applicationAmount) + "元" }</span></div>
                    <div><span>{ item.businessStateName }</span><span>{  Util.formatStr(item.businessTime) }</span></div>
                  </div>
                </div>
              )
            })
          */}
         
          {/* data.length === 0 ? <div style={{textAlign:'center', paddingTop:'2rem', color:"rgb(161, 167, 178)" }}> 没有相关数据</div> : null */}

          {/*
            <div className="superListJ" onClick={ ()=> this.goTransactionDetail() } >
              <div style={{ borderBottom:'1px solid #f2f4f7'}}><span style={{ color:'#fa063a'}}>锐意进取型</span><span></span></div>
              <div><span>当前资产</span><span>401.14</span></div>
              <div><span>最新收益</span><span>401.14</span></div>
            </div>
            
            <div className="superListJ">
              <div style={{ borderBottom:'1px solid #f2f4f7'}}><span style={{ color:'#fa063a'}}>锐意进取型</span><span></span></div>
              <div><span>当前资产</span><span>401.14</span></div>
              <div><span>最新收益</span><span>401.14</span></div>
            </div>
          */}
          </div>
          {
            zxFlag ? <ChooseTime callback={ this.ChooseTimeCallback.bind(this) } closeBack={this.closeChoose.bind(this)}/> : null
          }
        </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    QueryTradeRecords:state.QueryTradeRecords,
    SupperFundHome:state.SupperFundHome,
  }
}

export default connect(mapStateToProps)(HistoryProfit);

function GetDateStr(beginDate,AddDayCount=-15) {   
   var dd = new Date(beginDate.replace(/\-/g,'/'));  
   dd.setDate(dd.getDate()+AddDayCount);//获取AddDayCount天后的日期  
   var y = dd.getFullYear();   
   var m = (dd.getMonth()+1)<10?"0"+(dd.getMonth()+1):(dd.getMonth()+1);//获取当前月份的日期，不足10补0  
   var d = dd.getDate()<10?"0"+dd.getDate():dd.getDate();//获取当前几号，不足10补0  
   return y+"-"+m+"-"+d;   
} 



// WEBPACK FOOTER //
// ./src/components/product/HistoryProfit.js